export default "__VITE_ASSET__DV05gtll__"